import { Link } from "react-router-dom";
import { filmTypes } from "@/mocks/shortFilms";

const exploreLinks = [
  { label: "全部短片", to: "/category/shortfilms" },
  { label: "影视资讯", to: "/category/news" },
  { label: "站内搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-200 mt-16">
      <div className="container-page pt-12 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-lg text-background-50" />
              </span>
              <span className="font-heading text-lg font-extrabold tracking-tight text-background-50">
                小电影<span className="text-accent-500">.</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300 max-w-md">
              小电影是一个专注影视短片与行业动态的内容平台。我们每天挑选值得花二十分钟看完的短片，
              整理真实发生的影视新闻，让好作品和好故事被更多人看见。
            </p>
            <a
              href="mailto:hello@xiaodianying.studio"
              className="inline-flex items-center gap-2 mt-5 text-sm text-background-100 hover:text-accent-400 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line" />
              hello@xiaodianying.studio
            </a>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">浏览栏目</h3>
            <ul className="space-y-2.5">
              {exploreLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">短片类型</h3>
            <ul className="space-y-2.5">
              {filmTypes.map((type) => (
                <li key={type}>
                  <Link
                    to={`/category/shortfilms?type=${encodeURIComponent(type)}`}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {type}短片
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-400 leading-relaxed">
            © 2026 小电影 XiaoDianYing Studio. 保留所有权利。站内图片与内容均为虚构示例，仅用于界面演示。
          </p>
          <p className="text-xs text-background-400">
            本站不提供在线播放与下载服务
          </p>
        </div>
      </div>
    </footer>
  );
}